// extracted by mini-css-extract-plugin
module.exports = {"not_found_page":"NotFound_not_found_page__1XD4O"};